/* Sans Armure — Let's Hoop. A small pull-and-release basketball game. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } }

  function Game(root) {
    var cv = root.querySelector('[data-game-canvas]'), ctx = cv.getContext('2d');
    var elScore = root.querySelector('[data-game-score]'), elTime = root.querySelector('[data-game-time]');
    var elStreak = root.querySelector('[data-game-streak]'), elBest = root.querySelector('[data-game-best]');
    var elHint = root.querySelector('[data-game-hint]'), over = root.querySelector('[data-game-over]');
    var elFinal = root.querySelector('[data-game-final]'), elLine = root.querySelector('[data-game-line]');
    var again = root.querySelector('[data-game-again]'), live = root.querySelector('[data-game-live]');
    var SECONDS = parseInt(root.dataset.seconds, 10) || 45;
    var W = 0, H = 0, dpr = 1, g = 0, r = 16, vmax = 0, maxPull = 0;
    var hoop = { x: 0, y: 0, baseY: 0, w: 0, kick: 0 };
    var ball = null, aim = null, trail = [], bits = [], pops = [], rings = [], beats = [], flash = 0, beatAt = 0;
    var score = 0, streak = 0, makes = 0, best = parseInt(store('sa-game-best'), 10) || 0;
    var timeLeft = SECONDS, running = false, ended = false, last = 0, t = 0, kAng = -1.02, kPow = 0.72;

    function size() {
      var b = cv.getBoundingClientRect();
      dpr = Math.min(Math.max(window.devicePixelRatio || 1, 2), 3);
      W = b.width; H = b.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      r = Math.max(12, Math.min(22, Math.min(W, H) * 0.036));
      g = H * 2.3;
      vmax = Math.sqrt(1.9 * Math.max(W, H * 0.9) * g);
      maxPull = Math.min(W, H) * 0.42;
      hoop.w = r * 4.3; hoop.x = W * 0.86; hoop.baseY = H * 0.36; hoop.y = hoop.baseY;
      if (!ball || !ball.live) spawn();
    }
    function spawn() {
      var wide = W > H;
      ball = { x: W * (0.12 + Math.random() * (wide ? 0.36 : 0.22)), y: H * (0.58 + Math.random() * 0.2), vx: 0, vy: 0, live: false, rot: 0, touched: false, scored: false, age: 0, pop: 0 };
      trail = [];
    }
    function hud() {
      elScore.textContent = score; elStreak.textContent = streak; elBest.textContent = best;
      elTime.textContent = Math.max(0, Math.ceil(timeLeft));
      root.classList.toggle('is-hot', streak >= 3);
    }
    function reset() {
      score = 0; streak = 0; makes = 0; timeLeft = SECONDS; running = false; ended = false; bits = []; pops = [];
      over.hidden = true; root.classList.remove('is-over'); elHint.hidden = false; spawn(); hud();
    }
    function finish() {
      ended = true; running = false;
      var isBest = score > best; if (isBest) { best = score; store('sa-game-best', String(best)); }
      elFinal.textContent = score;
      elLine.textContent = isBest && score > 0 ? 'A new best. proof you were here.' : score > 0 ? 'proof you were here.' : 'The hoop is still there. Try again.';
      over.hidden = false; root.classList.add('is-over'); hud();
      if (live) live.textContent = 'Time. You scored ' + score + '.';
      if (again) again.focus();
    }
    function velocity(dx, dy) {
      var len = Math.hypot(dx, dy); if (len < 1) return null;
      var k = Math.min(len, maxPull) / maxPull;
      return { vx: dx / len * vmax * k, vy: dy / len * vmax * k, k: k };
    }
    function shoot(v) {
      if (!v || v.k < 0.12 || ball.live || ended) return;
      ball.vx = v.vx; ball.vy = v.vy; ball.live = true; ball.age = 0;
      if (!running) { running = true; elHint.hidden = true; }
    }
    function made() {
      var swish = !ball.touched, pts = (swish ? 3 : 2) + (streak >= 2 ? 1 : 0);
      ball.scored = true; score += pts; streak++; makes++; hoop.kick = 1;
      flash = swish ? 1 : .5; rings.push({ x: hoop.x - hoop.w / 2, y: hoop.y, r: hoop.w * .5, a: 1 }); if (swish) rings.push({ x: hoop.x - hoop.w / 2, y: hoop.y, r: hoop.w * .2, a: 1 }); beats.push({ x: 0, h: H * (swish ? .09 : .06) });
      pops.push({ x: hoop.x - hoop.w / 2, y: hoop.y - r * 2, a: 1, text: '+' + pts + (swish ? ' swish' : '') });
      if (!reduce) for (var i = 0; i < (swish ? 9 : 5); i++) bits.push({ x: hoop.x - hoop.w * Math.random(), y: hoop.y + r, vx: (Math.random() - .5) * 60, vy: -40 - Math.random() * 90, s: 4 + Math.random() * 6, a: 1, c: ['#6FA3E6', '#A9C8F0', '#FFFFFF', '#DCEBFF'][i % 4] });
      if (live) live.textContent = (swish ? 'Swish. ' : 'In. ') + score + ' points.';
      hud();
    }
    function hitPoint(px, py, pr) {
      var dx = ball.x - px, dy = ball.y - py, d = Math.hypot(dx, dy), min = r + pr;
      if (d >= min || d === 0) return;
      var nx = dx / d, ny = dy / d, vn = ball.vx * nx + ball.vy * ny;
      ball.x = px + nx * min; ball.y = py + ny * min;
      if (vn < 0) { ball.vx -= 1.55 * vn * nx; ball.vy -= 1.55 * vn * ny; }
      ball.touched = true;
    }
    function step(dt) {
      var py = ball.y;
      ball.vy += g * dt; ball.x += ball.vx * dt; ball.y += ball.vy * dt; ball.rot += ball.vx * dt / r; ball.age += dt;
      var fx = hoop.x - hoop.w, bx = hoop.x + 5;
      hitPoint(fx, hoop.y, 3); hitPoint(hoop.x, hoop.y, 3);
      if (ball.vx > 0 && ball.x + r > bx && ball.x < bx + r && ball.y > hoop.y - hoop.w * 1.15 - r && ball.y < hoop.y + r * 1.2) { ball.x = bx - r; ball.vx = -ball.vx * 0.5; ball.touched = true; }
      if (!ball.scored && ball.vy > 0 && py <= hoop.y && ball.y > hoop.y && ball.x > fx + 3 && ball.x < hoop.x - 3) made();
      if (ball.y > H + r * 3 || ball.x < -r * 4 || ball.x > W + r * 4 || ball.age > 5) {
        if (!ball.scored) { streak = 0; hud(); }
        if (timeLeft <= 0) finish(); else spawn();
      }
    }
    function drawBall(x, y, rot, alpha) {
      ctx.save(); ctx.globalAlpha = alpha; ctx.translate(x, y);
      var gr = ctx.createRadialGradient(-r * .35, -r * .4, r * .05, 0, 0, r);
      gr.addColorStop(0, '#FFFFFF'); gr.addColorStop(.35, '#A9CCF7'); gr.addColorStop(.8, '#3F82DC'); gr.addColorStop(1, '#1D4F9C');
      ctx.shadowColor = 'rgba(120,180,255,.9)'; ctx.shadowBlur = r * 1.4;
      ctx.fillStyle = gr; ctx.beginPath(); ctx.arc(0, 0, r, 0, 6.2832); ctx.fill();
      ctx.shadowColor = 'transparent'; ctx.rotate(rot);
      ctx.strokeStyle = 'rgba(11,36,74,.55)'; ctx.lineWidth = Math.max(1, r * .07);
      ctx.beginPath(); ctx.moveTo(-r, 0); ctx.lineTo(r, 0); ctx.moveTo(0, -r); ctx.lineTo(0, r);
      ctx.moveTo(-r * .72, -r * .7); ctx.quadraticCurveTo(-r * .2, 0, -r * .72, r * .7);
      ctx.moveTo(r * .72, -r * .7); ctx.quadraticCurveTo(r * .2, 0, r * .72, r * .7); ctx.stroke();
      ctx.restore();
    }
    function glow(c, b) { ctx.shadowColor = c; ctx.shadowBlur = b; }
    function predict(v) {
      var x = ball.x, y = ball.y, vx = v.vx, vy = v.vy, pts = [], hit = false, apex = null, fx = hoop.x - hoop.w;
      for (var k = 0; k < 90; k++) {
        var py = y; vy += g * .02; x += vx * .02; y += vy * .02;
        if (!apex && vy >= 0) apex = { x: x, y: y };
        if (vy > 0 && py <= hoop.y && y > hoop.y) { hit = x > fx + r * .7 && x < hoop.x - r * .7; pts.push({ x: x, y: y }); break; }
        if (x > hoop.x + 5 - r && y > hoop.y - hoop.w * 1.15 && y < hoop.y) break;
        if (y > H || x > W) break;
        pts.push({ x: x, y: y });
      }
      return { pts: pts, hit: hit, apex: apex };
    }
    function draw() {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H);
      var fy = H * 0.88, i, fx = hoop.x - hoop.w, bx = hoop.x + 5, bh = hoop.w * 1.15;
      var mono = '"IBM Plex Mono", ui-monospace, monospace';
      /* perspective floor grid */
      ctx.save(); ctx.lineWidth = 1;
      var fg = ctx.createLinearGradient(0, fy, 0, H); fg.addColorStop(0, 'rgba(120,180,255,.5)'); fg.addColorStop(1, 'rgba(120,180,255,0)');
      ctx.strokeStyle = fg; ctx.beginPath();
      for (i = -8; i <= 8; i++) { ctx.moveTo(W / 2 + i * W * .06, fy); ctx.lineTo(W / 2 + i * W * .2, H); }
      for (i = 0; i < 6; i++) { var gy = fy + (H - fy) * Math.pow(((i + (reduce ? 0 : (t * .25) % 1)) / 6), 1.8); ctx.moveTo(0, gy); ctx.lineTo(W, gy); }
      ctx.stroke();
      /* heartbeat horizon */
      glow('rgba(140,195,255,.9)', 10); ctx.strokeStyle = 'rgba(190,220,255,.85)'; ctx.lineWidth = 1.25; ctx.beginPath(); ctx.moveTo(0, fy);
      var ps = beats.slice().sort(function (a, b) { return a.x - b.x; });
      ps.forEach(function (b) { var s = W * .012, a = b.h; ctx.lineTo(b.x - s * 3, fy); ctx.lineTo(b.x - s * 2, fy - a * .25); ctx.lineTo(b.x - s, fy + a * .35); ctx.lineTo(b.x, fy - a); ctx.lineTo(b.x + s, fy + a * .55); ctx.lineTo(b.x + s * 2, fy); });
      ctx.lineTo(W, fy); ctx.stroke(); ctx.restore();
      /* hoop: light construction */
      ctx.save();
      ctx.strokeStyle = 'rgba(150,195,255,.3)'; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.moveTo(bx + 6, hoop.y + r); ctx.lineTo(bx + 6, fy); ctx.stroke();
      glow('rgba(140,195,255,.9)', 14); ctx.strokeStyle = '#DCEBFF'; ctx.lineWidth = 2; ctx.strokeRect(bx, hoop.y - bh, 6, bh + r);
      ctx.restore();
      var n = 7, drop = hoop.w * (0.95 - hoop.kick * 0.22), pinch = hoop.w * 0.2, sway = Math.sin(t * 9) * hoop.kick * 6;
      ctx.strokeStyle = 'rgba(190,220,255,' + (0.4 + hoop.kick * .5).toFixed(2) + ')'; ctx.lineWidth = 1; ctx.beginPath();
      for (i = 0; i <= n; i++) { var u = i / n, tx = fx + hoop.w * u; ctx.moveTo(tx, hoop.y); ctx.quadraticCurveTo(tx + sway, hoop.y + drop * .5, fx + pinch + (hoop.w - pinch * 2) * u + sway, hoop.y + drop); }
      for (var j = 1; j <= 3; j++) { var q = j / 3.4, ins = pinch * q; ctx.moveTo(fx + ins + sway * q, hoop.y + drop * q); ctx.lineTo(hoop.x - ins + sway * q, hoop.y + drop * q); }
      ctx.stroke();
      /* aim: predicted arc, apex, lock, readout */
      var v = aim ? velocity(aim.dx, aim.dy) : null, lock = false;
      if (v && !ball.live) {
        var pr = predict(v); lock = pr.hit;
        ctx.save(); glow(lock ? 'rgba(255,255,255,.9)' : 'rgba(120,180,255,.8)', lock ? 14 : 8);
        for (i = 0; i < pr.pts.length; i += 2) { var a = 1 - i / (pr.pts.length + 6); ctx.fillStyle = lock ? 'rgba(255,255,255,' + a.toFixed(2) + ')' : 'rgba(150,200,255,' + (a * .8).toFixed(2) + ')'; ctx.beginPath(); ctx.arc(pr.pts[i].x, pr.pts[i].y, lock ? 2.4 : 1.8, 0, 6.2832); ctx.fill(); }
        if (pr.apex && pr.apex.y > 8) { ctx.strokeStyle = 'rgba(190,220,255,.6)'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(pr.apex.x - 7, pr.apex.y); ctx.lineTo(pr.apex.x + 7, pr.apex.y); ctx.moveTo(pr.apex.x, pr.apex.y - 7); ctx.lineTo(pr.apex.x, pr.apex.y + 7); ctx.stroke(); }
        ctx.restore();
        var len = Math.hypot(aim.dx, aim.dy), cl = Math.min(1, maxPull / len);
        if (aim.drag) { var ex = ball.x - aim.dx * cl, ey = ball.y - aim.dy * cl; ctx.strokeStyle = 'rgba(190,220,255,.55)'; ctx.lineWidth = 1 + v.k * 2; ctx.beginPath(); ctx.moveTo(ball.x, ball.y); ctx.lineTo(ex, ey); ctx.stroke(); ctx.beginPath(); ctx.arc(ex, ey, 5, 0, 6.2832); ctx.stroke(); }
        ctx.strokeStyle = 'rgba(220,235,255,.9)'; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(ball.x, ball.y, r * 2.1, -1.5708, -1.5708 + 6.2832 * v.k); ctx.stroke();
        ctx.font = '500 10px ' + mono; ctx.textAlign = 'left'; ctx.fillStyle = 'rgba(220,235,255,.9)';
        var deg = Math.round(Math.atan2(-aim.dy, aim.dx) * 57.2958);
        ctx.fillText(deg + '°  ' + Math.round(v.k * 100) + '%', ball.x + r * 2.6, ball.y - 4);
        ctx.fillStyle = lock ? '#FFFFFF' : 'rgba(170,205,250,.6)'; ctx.fillText(lock ? 'LOCKED' : 'SEEKING', ball.x + r * 2.6, ball.y + 10);
      }
      /* ribbon trail */
      if (trail.length > 1) { ctx.save(); ctx.lineCap = 'round'; glow('rgba(140,195,255,.9)', 12);
        for (i = 1; i < trail.length; i++) { var k2 = i / trail.length; ctx.strokeStyle = 'rgba(170,210,255,' + (k2 * .55).toFixed(2) + ')'; ctx.lineWidth = r * 1.5 * k2; ctx.beginPath(); ctx.moveTo(trail[i - 1].x, trail[i - 1].y); ctx.lineTo(trail[i].x, trail[i].y); ctx.stroke(); }
        ctx.restore(); }
      var bob = ball.live ? 0 : Math.sin(t * 2.2) * (reduce ? 0 : 3);
      if (!ball.live && !v) { ctx.save(); ctx.translate(ball.x, ball.y + bob); ctx.rotate(reduce ? 0 : t * .8); ctx.strokeStyle = 'rgba(190,220,255,.7)'; ctx.lineWidth = 1; ctx.setLineDash([r * .5, r * .55]); ctx.beginPath(); ctx.arc(0, 0, r * 1.9, 0, 6.2832); ctx.stroke(); ctx.restore(); }
      drawBall(ball.x, ball.y + bob, ball.rot, 1);
      /* rim on top of the ball */
      ctx.save(); glow(lock || hoop.kick > .05 ? '#FFFFFF' : 'rgba(140,195,255,.95)', 12 + hoop.kick * 26 + (lock ? 12 : 0));
      ctx.strokeStyle = '#FFFFFF'; ctx.lineWidth = 3.5; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(fx, hoop.y); ctx.lineTo(hoop.x + 5, hoop.y); ctx.stroke(); ctx.restore();
      if (lock) { var s2 = 6 + Math.sin(t * 10) * 2, cx = fx + hoop.w / 2; ctx.strokeStyle = 'rgba(255,255,255,.9)'; ctx.lineWidth = 1.25; ctx.beginPath();
        [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(function (c) { var ox = cx + c[0] * (hoop.w / 2 + s2), oy = hoop.y + c[1] * (r + s2); ctx.moveTo(ox, oy - c[1] * 8); ctx.lineTo(ox, oy); ctx.lineTo(ox - c[0] * 8, oy); }); ctx.stroke(); }
      rings.forEach(function (o) { ctx.strokeStyle = 'rgba(220,235,255,' + o.a.toFixed(2) + ')'; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.ellipse(o.x, o.y, o.r, o.r * .38, 0, 0, 6.2832); ctx.stroke(); });
      bits.forEach(function (b) { ctx.globalAlpha = b.a; ctx.fillStyle = b.c; ctx.beginPath(); ctx.ellipse(b.x, b.y, b.s * .82, b.s, 0, 0, 6.2832); ctx.fill(); ctx.strokeStyle = 'rgba(220,235,255,.5)'; ctx.lineWidth = .8; ctx.beginPath(); ctx.moveTo(b.x, b.y + b.s); ctx.lineTo(b.x + 2, b.y + b.s * 2.6); ctx.stroke(); });
      ctx.globalAlpha = 1;
      ctx.font = '500 ' + Math.max(11, r * .8) + 'px ' + mono; ctx.textAlign = 'center';
      pops.forEach(function (p) { ctx.fillStyle = 'rgba(255,255,255,' + p.a.toFixed(2) + ')'; ctx.fillText(p.text.toUpperCase(), p.x, p.y); });
      if (flash > 0) { ctx.fillStyle = 'rgba(200,225,255,' + (flash * .16).toFixed(3) + ')'; ctx.fillRect(0, 0, W, H); }
    }
    function frame(now) {
      var dt = Math.min(0.05, (now - last) / 1000 || 0); last = now; t += dt;
      if (running && !ended) { timeLeft -= dt; if (timeLeft <= 0) { timeLeft = 0; if (!ball.live) finish(); } elTime.textContent = Math.ceil(timeLeft); root.classList.toggle('is-late', timeLeft <= 10); }
      if (makes >= 4 && !reduce) hoop.y = hoop.baseY + Math.sin(t * (0.9 + Math.min(makes, 14) * 0.05)) * H * Math.min(0.13, 0.05 + makes * 0.008);
      hoop.kick = Math.max(0, hoop.kick - dt * 1.6);
      if (ball.live) {
        var near = !reduce && !ball.scored && ball.vy > 0 && ball.y < hoop.y + r && Math.hypot(ball.x - (hoop.x - hoop.w / 2), ball.y - hoop.y) < hoop.w * 1.3;
        var bdt = dt * (near ? 0.4 : 1), sub = 4; for (var i = 0; i < sub && ball.live; i++) step(bdt / sub);
        if (ball.live && !reduce) { trail.push({ x: ball.x, y: ball.y, rot: ball.rot }); if (trail.length > 16) trail.shift(); }
      }
      bits = bits.filter(function (b) { b.vy -= 30 * dt; b.x += b.vx * dt; b.y += b.vy * dt; b.a -= dt * .7; return b.a > 0; });
      rings = rings.filter(function (o) { o.r += W * .35 * dt; o.a -= dt * 1.5; return o.a > 0; });
      beats = beats.filter(function (b) { b.x += W * .7 * dt; return b.x < W + 60; });
      if (!reduce && t - beatAt > 1.6) { beatAt = t; beats.push({ x: 0, h: H * .02 }); }
      flash = Math.max(0, flash - dt * 2.2);
      pops = pops.filter(function (p) { p.y -= 34 * dt; p.a -= dt * .9; return p.a > 0; });
      draw();
      requestAnimationFrame(frame);
    }
    function pt(e) { var b = cv.getBoundingClientRect(); return { x: e.clientX - b.left, y: e.clientY - b.top }; }
    cv.addEventListener('pointerdown', function (e) {
      if (ball.live || ended) return;
      var p = pt(e); aim = { sx: p.x, sy: p.y, dx: 0, dy: 0, drag: true };
      try { cv.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) { if (!aim || !aim.drag) return; var p = pt(e); aim.dx = aim.sx - p.x; aim.dy = aim.sy - p.y; });
    function release() { if (!aim || !aim.drag) return; shoot(velocity(aim.dx, aim.dy)); aim = null; }
    cv.addEventListener('pointerup', release); cv.addEventListener('pointercancel', function () { aim = null; });
    function keyAim() { aim = { dx: Math.cos(kAng) * maxPull * kPow, dy: Math.sin(kAng) * maxPull * kPow, drag: false }; }
    cv.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowUp') kAng -= 0.035; else if (k === 'ArrowDown') kAng += 0.035;
      else if (k === 'ArrowRight') kPow = Math.min(1, kPow + 0.02); else if (k === 'ArrowLeft') kPow = Math.max(0.15, kPow - 0.02);
      else if (k === ' ' || k === 'Enter') { e.preventDefault(); keyAim(); shoot(velocity(aim.dx, aim.dy)); aim = null; return; }
      else return;
      e.preventDefault(); kAng = Math.max(-1.5, Math.min(-0.2, kAng)); if (!ball.live) keyAim();
    });
    cv.addEventListener('blur', function () { if (aim && !aim.drag) aim = null; });
    if (again) again.addEventListener('click', function () { reset(); cv.focus(); });
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(cv); else window.addEventListener('resize', size);
    size(); hud(); requestAnimationFrame(frame);
  }
  function init() { document.querySelectorAll('[data-game]').forEach(function (el) { if (el.dataset.ready) return; el.dataset.ready = '1'; Game(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
